import type { LinkTarget } from "../../aysa_api/models/link_target.types";
import type { RichText } from "../../aysa_api/models/rich_text.types";
import type { Image } from "../../aysa_api/models/image.types";
import type { Link } from "../../aysa_api/models/link.types";

export enum MissionDetail_MissionBadge_BadgeStyle {
  UNSPECIFIED = 0,
  STANDARD = 1,
  FRAMED = 2,
}

export interface MissionSuccessNotification {
  // E.g.: Mission
  title: string;
  missionStage: MissionSuccessNotification_MissionStage;
  congratulationsStage: MissionSuccessNotification_CongratulationStage;
  linkTarget?: LinkTarget;
  missionIdentifier: MissionIdentifier;
}

export interface MissionSuccessNotification_MissionStage {
  // E.g.: Enable push notifications
  title: string;
}

export interface MissionSuccessNotification_CongratulationStage {
  // E.g.: Congrats 🎉
  // E.g.: Enable push notifications
  title: string;
  // deprecated use RichText description instead
  deprecatedDescription: string;
  // E.g.: 200
  reward: number;
  // E.g.: 200 Coins are waiting in your Wallet. Claim then when you are ready.
  description: RichText;
  cta?: MissionSuccessNotification_CongratulationStage_CTA;
}

export interface MissionSuccessNotification_CongratulationStage_CTA {
  // E.g.: Claim your reward
  label: string;
}

export interface MissionIdentifier {
  missionId: number;
  tierIndex: number;
}

export interface MissionDetail {
  deprecatedMissionId: number;
  badge: MissionDetail_MissionBadge;
  summary: MissionDetail_MissionSummary;
  bottomSheet?: MissionDetail_MissionBottomSheet;
  expiryLabel?: string;
  missionStatus: MissionDetail_MissionStatus;
  missionIdentifier: MissionIdentifier;
  info?:
    | {
        $case: "hint";
        hint: MissionDetail_MissionHint;
      }
    | {
        $case: "progressBar";
        progressBar: MissionDetail_ProgressBar;
      }
    | {
        $case: "claimInfo";
        claimInfo: MissionDetail_ClaimInfo;
      };
}

export interface MissionDetail_ClaimInfo {
  // E.g.: Claim now
  ctaLabel: string;
  // E.g.: Claim until 15.08.2025
  untilLabel?: string;
}

export interface MissionDetail_MissionHint {
  // E.g.: Available from 31.07.2025
  // E.g.: You nailed it – your coins are ready to shop.
  hint: string;
}

export interface MissionDetail_MissionStatus {
  status?:
    | {
        $case: "active";
        active: MissionDetail_MissionStatus_Active;
      }
    | {
        $case: "complete";
        complete: MissionDetail_MissionStatus_Complete;
      }
    | {
        $case: "pending";
        pending: MissionDetail_MissionStatus_Pending;
      }
    | {
        $case: "claimable";
        claimable: MissionDetail_MissionStatus_Claimable;
      };
}

export interface MissionDetail_MissionStatus_Active {}

export interface MissionDetail_MissionStatus_Complete {}

export interface MissionDetail_MissionStatus_Pending {}

export interface MissionDetail_MissionStatus_Claimable {}

export interface MissionDetail_MissionSummary {
  // E.g.: Spend 100$ in Total
  title: string;
  // E.g.: Keep shopping your favorites and unlock rewards along the way.
  description: string;
}

export interface MissionDetail_MissionBadge {
  image: Image;
  // E.g.: +200
  label?: string;
  style: MissionDetail_MissionBadge_BadgeStyle;
}

export interface MissionDetail_MissionBottomSheet {
  badge: MissionDetail_MissionBadge;
  summary: MissionDetail_MissionSummary;
  // E.g.: Link.label = Start now
  cta?: Link;
}

// Both fields have to add to 100
// E.g.: confirmed = 40, pending = 60
export interface MissionDetail_ProgressBar {
  // [0-100]
  percentage: number;
  // E.g.: 1/10
  label: string;
}
